import {
	Button,
	Card,
	CardContent,
	CircularProgress,
	Grid,
	Typography
} from '@material-ui/core';
import sqLogo from 'assets/img/sure_quote_website_logo.png';
import FormInput from 'components/Wrappers//materialUIWrappers/components/FormInput';
import FormInputPassword from 'components/Wrappers/materialUIWrappers/components/FormInputPassword';
import React from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { showSnack, successWarning } from 'reducers/NotificationReducer';
import { reduxForm } from 'redux-form';
import store from 'store';
import './Register.css';
import {
	required,
	number,
	saId,
	email,
	isEmptyOrSpaces
} from 'helpers/ValidationHelpers';
import { submitSignup } from '../RegisterMutations';
import { HalfFieldSmall as CustomField } from 'components/CustomFields/CustomFields.jsx';

const form = 'brokerage';

class BrokerageSignup extends React.Component {
	state = {
		brokerUser: true,
		checkValidation: false,
		loading: false
	};

	passwordMatch = value => {
		if (isEmptyOrSpaces(value)) return undefined;

		if (store.getState().form[form].values['su_password'] !== value) {
			return 'Does not match password';
		}
		return undefined;
	};

	emailMatch = value => {
		if (isEmptyOrSpaces(value)) return undefined;

		if (store.getState().form[form].values['su_email'] !== value) {
			return 'Does not match email';
		}
		return undefined;
	};

	submit = () => {
		if (store.getState().form[form].syncErrors) {
			this.setState({ checkValidation: true });
			store.dispatch(
				showSnack({
					message: 'Invalid data.',
					color: 'danger'
				})
			);
			return;
		}
		this.setState({ loading: true });

		let dat = store.getState().form[form].values;
		dat.brokerUser = this.state.brokerUser;

		var input = {
			clientMutationId: 'helloFudger',
			type: 1,
			data: dat
		};
		this.props
			.mutate({
				variables: {
					input
				}
			})
			.then(resp => {
				this.setState({ loading: false });

				const data = resp.data.Register;
				if (data.error) {
					store.dispatch(
						showSnack({
							message: data.error,
							color: 'danger'
						})
					);
				} else {
					store.dispatch(
						successWarning({
							open: true,
							title: 'Brokerage Profile Successfully Created.',
							onConfirm: () =>
								this.props.history.push({
									pathname: '/app/portal/login'
								})
						})
					);
				}
			})
			.catch(error => {
				this.setState({ loading: false });
				store.dispatch(
					showSnack({
						message:
							'Unfortunately an error occured. We have captured the error and will notify our developers. Sorry for the inconvenience!',
						color: 'danger'
					})
				);
			});
	};

	render() {
		return (
			<Card className="registerContainer">
				<CardContent>
					<div style={{ textAlign: 'center', marginTop: '3vh' }}>
						<img className="sqLogoR" src={sqLogo} alt="SureQuote Logo" />
					</div>

					<h3 className={'sqHeadingCenter'}>Register as a Brokerage</h3>
					<h5 className={'sqHeadingCenter'}>Try Sure Quote for free and see how easy it will make your life</h5>
					<br/>
					<Typography>*Simply fill in your details in the form below, and we will set you up with free access to try it out for yourself.</Typography>


					<Grid container spacing={24}>
						<CustomField
							name={'sbad_name'}
							component={FormInput}
							label={'Name *'}
							validate={[required]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'sbad_surname'}
							component={FormInput}
							label={'Surname *'}
							validate={[required]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'sbad_id_number'}
							component={FormInput}
							label={'Id Number *'}
							validate={[required, number, saId]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'sbad_brokerageName'}
							component={FormInput}
							label={'Brokerage Name *'}
							validate={[required]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'sbad_fsb'}
							component={FormInput}
							label={'FSB Registration Number *'}
							validate={[required]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'su_email'}
							component={FormInput}
							label={'Email Address *'}
							validate={[required, email]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'su_email_confirm'}
							component={FormInput}
							label={'Confirm Email Address *'}
							validate={[required, email, this.emailMatch]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'su_password'}
							component={FormInputPassword}
							label={'Password *'}
							validate={[required]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'confirm_password'}
							component={FormInputPassword}
							label={'Confirm Password *'}
							validate={[required, this.passwordMatch]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'su_cellNumber'}
							component={FormInput}
							label={'Phone Number *'}
							validate={[required, number]}
							checkValidation={this.state.checkValidation}
						/>

						<CustomField
							name={'sbad_streetAddress'}
							component={FormInput}
							label={'Office Address *'}
							validate={[required]}
							checkValidation={this.state.checkValidation}
						/>
					</Grid>
					<Button
						fullWidth
						variant="outlined"
						className="outlinedButton"
						color="primary"
						onClick={() => (!this.state.loading ? this.submit() : {})}
						style={{ margin: 'auto', marginTop: '8vh', marginBottom: '15px' }}
					>
						{this.state.loading ? (
							<CircularProgress size={20} />
						) : (
							'REGISTER NOW'
						)}
					</Button>
				</CardContent>
			</Card>
		);
	}
}

BrokerageSignup = reduxForm({
	form: form,
	destroyOnUnmount: false
})(BrokerageSignup);

BrokerageSignup = connect(() => ({}))(BrokerageSignup);

BrokerageSignup = graphql(submitSignup)(BrokerageSignup);

export default BrokerageSignup;



// WEBPACK FOOTER //
// ./src/views/Register/components/BrokerageSignup.jsx